export default __webpack_public_path__ + "static/media/shangbiao3.a2bf1eed.png";